export default __webpack_public_path__ + "static/media/roadmap_2.e362b6cf.png";